import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

const initialState = {
  phone: '',
  code: '',
  name: '',
  email: '',
  password: '',
  isStartedAsGuest: false,
  rideCanceledParams: null,
  popup: {},
  isBookerCleared: false,
  isWebBookerPortrait: false,
  upcomingRideLocations: '',
  isPaymentDone: false,
};

const reducer = (state = initialState, action) => {
  const {
    type,
    phone,
    code,
    name,
    email,
    password,
    isStartedAsGuest,
    rideCanceledParams,
    popup,
    isBookerCleared,
    isWebBookerPortrait,
    upcomingRideLocations,
    isPaymentDone,
  } = action;
  switch (type) {
    case 'updatePhone':
      return { ...state, phone };
    case 'updateCode':
      return { ...state, code };
    case 'updateName':
      return { ...state, name };
    case 'updateEmail':
      return { ...state, email };
    case 'updatePassword':
      return { ...state, password };
    case 'updateIsStartedAsGuest':
      return { ...state, isStartedAsGuest };
    case 'updateRideCanceledParams':
      return { ...state, rideCanceledParams };
    case 'updatePopup':
      return { ...state, popup };
    case 'updateIsBookerCleared':
      return { ...state, isBookerCleared };
    case 'updateIsWebBookerPortrait':
      return { ...state, isWebBookerPortrait };
    case 'updateUpcomingRideLocations':
      return { ...state, upcomingRideLocations };
    case 'updateIsPaymentDone':
      return { ...state, isPaymentDone };
    case 'clearBookerStore':
      return {};
    default:
      return { ...state };
  }
};

const logger = ({ getState }) => {
  return next => action => {
    const { type, ...rest } = action;
    const setItem = ({ key, value = initialState[key] }) => {
      try {
        // Set from local storage by key
        window.localStorage.setItem(key, JSON.stringify(value));
      } catch (error) {
        console.log(error);
      }
    };
    if (type === 'clearBookerStore') {
      Object.keys(initialState).forEach(key => {
        setItem({ key });
      });
    } else {
      const [key = '', value] = Object.entries(rest)[0];
      setItem({ key, value });
    }
    // Call the next dispatch method in the middleware chain.
    const returnValue = next(action);

    console.log('logger state after dispatch', getState());
    // This will likely be the action itself, unless
    // a middleware further in chain changed it.
    return returnValue;
  };
};

const loadState = state => {
  return Object.keys(state).reduce((obj, key) => {
    let value;
    try {
      // Get from local storage by key
      const item = window.localStorage.getItem(key);
      // Parse stored json or if none return initialValue
      value = item ? JSON.parse(item) : state[key];
    } catch (error) {
      // If error also return initialValue
      console.log(error);
      value = state[key];
    }
    return { ...obj, [key]: value };
  }, {});
};

const persistedStore = loadState(initialState);

const store = createStore(reducer, persistedStore, applyMiddleware(thunk, logger));

export default store;
